export enum AttributeAbbreviation {
  DoubleStaff = 'DB',
  AllergyVehicle = 'AF',
  DoubleChildPillows = 'BK',
  ChildSeat = 'BS',
  Combi = 'CO',
  NoBusVan = 'EB',
  FoldableWheelchair = 'HR',
  ElectricWheelchair = 'PM',
  NeedsBus = 'RB',
  WheelchairTaxi = 'RT',
  Walker = 'RU',
  LargeCar5 = 'S5',
  LargeCar6 = 'S6',
  LargeCar7 = 'S7',
  LargeCar8 = 'S8',
  SchoolTrip = 'SK', // Don't use
  SchoolSign = 'SS', // Don't use
  StairLift = 'TK',
  TransportWheelchair = 'TS',
  PickupDropOff = 'XS',
  Assistant = 'AS',
  Seat = 'SÄ',
  Space = 'UT',
  FossilFree = 'FO',
  RoutePlan = 'RP', // Don't use
  TheoreticalCalculation = 'TB', // Don't use
  ManualTrip = 'MT',
  Corona = 'CR',
  ServiceTrip = 'FT',
  PersonRegistration = 'PR',
  Vänersborg = 'VÄ',
  Kungälv = 'KÄ',
  Strömstad = 'SM',
  SeatBeltPillow = 'BA',
  Kombi = 'KO',
  Adult = 'VU',
  NeedsFrontSeat = 'SF',
  Tanum = 'TN',
  TaxiVäst = 'TV',
  ApprovedSoloTravel = 'EN',
  Trolley = 'BV',
  OkToLeaveAlone = 'OK',
  HandOver = 'HH',
  BoråsBil = 'BO',
  JönköpingsBil = 'JÖ',
  Wheelchair = 'RL',
  FrontSeat = 'FR',
  CanTravelByCar = 'PB',
  SpecialEducationSchool = 'SA',
  CVD = 'CV',
  Animal = 'DJ',
  AdaptedPrimaryAndSecondarySchool = 'AG',
  ChildBoosterSeat = 'BP',
  ChildBoosterSeat9To18Kg = 'B1',
  ChildBoosterSeat15To36Kg = 'B2',
  LowCar = 'LB',
  StationWagon = 'ST',
  OneWheelchair = 'R1',
  Maxi5 = '5',
  Maxi6 = '6',
  Maxi7 = '7',
  Maxi8 = '8',
  Maxi9 = '9',
  Maxi10 = '10',
  Maxi11 = '11',
  Maxi12 = '12',
  Maxi13 = '13',
  Maxi14 = '14',
  Maxi15 = '15',
  Maxi16 = '16',
  FourWheelDrive = '4W',
  FoldableWheelchairNo = 'SR',
  TramAgreement = 'SP',
}
